/* eslint-disable */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { MemoryRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import icimsI18next from '@icims-design-system/i18next';
import { CircularProgress, CssBaseline } from '@material-ui/core';
import { store } from './redux/store';
import Root from './components/Root';
import { lightConfig } from '@icimscorp/mui/build/theme';
import { lightThemeAcs } from '@icimscorp/mui-acs/build/acs-theme';
import { localeConfig } from './config';
import './styles/index.css';

const lightTheme = createTheme({
  ...lightConfig,
  ...lightThemeAcs,
});

const renderApp = () => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <I18nextProvider i18n={icimsI18next(localeConfig)}>
      <ThemeProvider theme={lightTheme}>
        <React.Suspense fallback={<CircularProgress />}>
          <Provider store={store}>
            <CssBaseline />
            <MemoryRouter basename="/">
              <Root />
            </MemoryRouter>
          </Provider>
        </React.Suspense>
      </ThemeProvider>
    </I18nextProvider>,
  );
};

renderApp();
